import { useMutation, useQueryClient } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { FicheDePrep } from '@teetsh/app/src/types/sequences';
import { deserializeFicheDePreps } from '@teetsh/app/src/queries/sequences/serializer';
import { fdpQueryKeys } from '@teetsh/app/src/queries/fdp/useFicheDePrep';
import { SEQUENCES_LIST_KEY } from '@teetsh/app/src/queries/sequences/useSequencesFolders';
import { SEQUENCE_KEY } from '@teetsh/app/src/queries/sequences/useSequence';
import { AxiosError } from 'axios';
import useNotification from '@teetsh/app/src/containers/App/Notifications/useNotification';
import { useLimitReached } from '@teetsh/app/src/components/LimitReached/useLimitReached';
import { useTranslation } from 'react-i18next';

export function useDuplicateFicheDePrep() {
  const queryClient = useQueryClient();
  const { notifyError } = useNotification();
  const { openLimitModal } = useLimitReached();
  const { t } = useTranslation(['sequence']);
  const { mutateAsync } = useMutation<
    FicheDePrep,
    AxiosError,
    {
      sequenceId: string;
      ficheDePrepId: string;
    }
  >({
    mutationFn: ({ sequenceId, ficheDePrepId }) =>
      request(
        `/sequences/${sequenceId}/fiches-de-prep/${ficheDePrepId}/duplicate`,
        {
          method: 'POST',
        },
      ).then(fdp => deserializeFicheDePreps(fdp)),
    onSuccess: fdp => {
      queryClient.setQueryData(
        fdpQueryKeys.detail(fdp.sequenceId, fdp.id),
        fdp,
      );
      queryClient.invalidateQueries({
        queryKey: [SEQUENCES_LIST_KEY],
      });
      queryClient.invalidateQueries({
        queryKey: [SEQUENCE_KEY, fdp.sequenceId],
      });
    },
    onError: err => {
      if (err?.response?.status === 403) {
        openLimitModal({
          requiredPlan: (err?.response as any)?.data?.requiredPlan,
          limit: (err?.response as any)?.data?.limit,
        });
        return;
      }
      notifyError({
        title: t('sequence:messages.seance.createError'),
      });
    },
  });
  return mutateAsync;
}
